import { createIcon } from '@chakra-ui/react';

export const TagHighRiskIcon = createIcon({
  displayName: 'TagHighRiskIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M6.125 15.9792L4.95833 14.8333L10 9.79167L15.0417 14.8333L13.875 15.9792L10 12.1042L6.125 15.9792ZM6.125 10.2083L4.95833 9.04167L10 4.02083L15.0417 9.04167L13.875 10.2083L10 6.3125L6.125 10.2083Z"
      fill="currentColor"
    />
  ),
  defaultProps: {
    width: '20px',
    height: '20px',
  },
});
